import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { ClickActionEvent } from '../util/analytics'


function Copyright() {
  return (
    <Typography variant="body2" color='textSecondary'  align="center">
      {'NoCopyright © '}
      <Link color="inherit" href="javedinfinite.com">
      javedinfinite.com
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

// footer styles moved to sx

export default function Footer(props) {
  
  const { title } = props;

  const socialContactClickedEvent = (contactName) => {
    ClickActionEvent("FooterContact " + contactName + "link footer", "Footer section", "Social contact clicked from footer")
  }

  return (
    <Box component="footer" sx={{ backgroundColor: '#2c3f46', color: 'white' }}>
      <Container maxWidth="xl"  >
        <Typography variant="h6" align="center" gutterBottom>
          {title}  
        </Typography>

        {/* Crawlable internal link to help search engines discover important pages */}
        {/* <Typography variant="body2" align="center" sx={{ mt: 1 }}>
          <Link href="/age-calculator" color="inherit">Age Calculator</Link>
        </Typography> */}
        <Typography variant="h6" align="center" gutterBottom>
      <Link   href="https://www.instagram.com/javedinfinite/" target="_blank" rel="noreferrer noopener" onClick={() => socialContactClickedEvent('instagram')}>
        <InstagramIcon style={{ color: '#e4455f',   }}  />
      </Link>{' '}
      <Link   href="https://www.facebook.com/people/Javed-Akhtar/100004054069579/" target="_blank" rel="noreferrer noopener" onClick={() => socialContactClickedEvent('facebook')}>
        <FacebookIcon style={{ color: '#3b5999',   }}  />
      </Link>{' '}
      <Link   href="https://www.linkedin.com/in/javed-akhtar-07370613b/" target="_blank" rel="noreferrer noopener" onClick={() => socialContactClickedEvent('linkedin')}>
        <LinkedInIcon style={{ color: '#0077B5',   }}  />
      </Link>{' '}
      <Link   href="https://twitter.com/javedinfinite" target="_blank" rel="noreferrer noopener" onClick={() => socialContactClickedEvent('twitter')}>
        <TwitterIcon style={{ color: '#55acee',  }}  />
      </Link>{' '}
      <Link   href="https://www.youtube.com/@javedinfinite" target="_blank" rel="noreferrer noopener" onClick={() => socialContactClickedEvent('youtube')}>
        <YouTubeIcon style={{ color: '#cd201f',   }}  />
      </Link>{' '}
      <Link
       href="https://medium.com/@javedinfinite"
       target="_blank"
       rel="noreferrer noopener"
       onClick={() => socialContactClickedEvent('medium')}
      >
      {/* <img src="https://img.icons8.com/fluency/48/000000/medium-logo.png"/> */}
      {/* testing  */}
      <img loading="lazy" src="https://img.icons8.com/ios-glyphs/30/000000/medium-monogram.png" alt="medium" />
      </Link> 
        </Typography>
 
        <Copyright />
      </Container>
    </Box>
  );
}

Footer.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string,
};
